import { ExhibitorStand } from "../store/exhibitors.data"


export const getProgramIdsByExhibitorIds = (exhibitorStands: { [sId: string]: ExhibitorStand }): { [eId: string]: string[]} => {
  const programIdsByExhibitor: { [eId: string]: string[] } = {}
  Object.values(exhibitorStands).filter(s => s.programId && s.exhibitorId).forEach(s => {
    if (!programIdsByExhibitor[s.exhibitorId]) programIdsByExhibitor[s.exhibitorId] = []
    programIdsByExhibitor[s.exhibitorId].push(s.programId)
  })
  return programIdsByExhibitor
}